export default __webpack_public_path__ + "static/media/34854_FINCANTIERI_SI_SPA.0d3bca03.pdf";